"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkedHashTag = exports.HashTag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const clsx_1 = __importDefault(require("clsx"));
const HashTag_module_css_1 = __importDefault(require("./HashTag.module.css"));
/**
 * HashTag component used to render HashTags associated with content
 */
function HashTag({ hashTag }) {
    return ((0, jsx_runtime_1.jsx)("span", { className: (0, clsx_1.default)(HashTag_module_css_1.default.hashTag, web_sds_c_1.TypographyVariantToClassName[web_sds_c_1.TypographyVariant.CaptionEmphasis]), children: `#${hashTag}` }));
}
exports.HashTag = HashTag;
/**
 * HashTag that acts as a link as well
 */
function LinkedHashTag({ hashTag, href, onClick, ariaLabel, dataTestId, }) {
    return ((0, jsx_runtime_1.jsx)("a", { className: HashTag_module_css_1.default.link, href: href, target: "_blank", onClick: onClick, "aria-label": ariaLabel, "data-testid": dataTestId, children: (0, jsx_runtime_1.jsx)(HashTag, { hashTag: hashTag }) }));
}
exports.LinkedHashTag = LinkedHashTag;
//# sourceMappingURL=HashTag.js.map